import type { GetPricingTemplatesResponse } from '@vy/api-definition';
import { GetPricingTemplatesResponseSchema } from '@vy/api-definition';
import type { UseQueryOptions, QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useGetPricingTemplates(options?: UseQueryOptions<GetPricingTemplatesResponse>) {
  const queryKey = queryKeys.pricingTemplate();
  const response = useQuery({
    queryKey,
    queryFn: async () => {
      const publicApi = getPrivateApi();
      const pricingTemplates = await publicApi.getPricingTemplates();

      return GetPricingTemplatesResponseSchema.parse(pricingTemplates);
    },
    ...options,
  });

  return response.data;
}

export async function prefetchGetPricingTemplates(queryClient: QueryClient) {
  await queryClient.prefetchQuery(queryKeys.pricingTemplate(), async () => {
    const publicApi = getPrivateApi();
    const pricingTemplates = await publicApi.getPricingTemplates();

    return GetPricingTemplatesResponseSchema.parse(pricingTemplates);
  });
}
